export enum ValueType {
  COLOR = "1",
  IMAGE = "2",
  SELF_NAME = "3",
}
